export default __webpack_public_path__ + "static/media/x.f5e8752e.svg";